export const GET_REQUIREMENT = 'REQUIREMENT/get_requirement';
export const GET_SINGLE_REQUIREMENT = 'REQUIREMENT/GET_SINGLE_REQUIREMENT';
export const UPDATE_REQUIREMENT = 'REQUIREMENT/update_requirement';
export const CREATE_REQUIREMENT = 'REQUIREMENT/create_requirement';
export const REMOVE_REQUIREMENT = 'REQUIREMENT/remove_requirement';
export const GET_TAG = 'REQUIREMENT/get_tag';
export const REMOVE_TAG = 'REQUIREMENT/remove_tag';
export const TAG = 'REQUIREMENT/tag';
export const GET_APPLICATION_STATUS = 'REQUIREMENT/get_applicantion_status';
export const GET_MENU_LIST = 'REQUIREMENT/get_menu_list';

export const FORM_DATA = {
  title_en: '',
  title_tl: '',
  sequence: '',
  description_en: '',
  description_tl: '',
  is_active: '',
  how_tos_menu_id: '',
};
